import React from "react";

const CyberSecurityLanding = () => {
  // 🔹 Free Pexels images related to cybersecurity / tech theme
  const logos = [
    "https://images.pexels.com/photos/5380646/pexels-photo-5380646.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.pexels.com/photos/5473952/pexels-photo-5473952.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.pexels.com/photos/5380611/pexels-photo-5380611.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.pexels.com/photos/5380614/pexels-photo-5380614.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.pexels.com/photos/5474297/pexels-photo-5474297.jpeg?auto=compress&cs=tinysrgb&w=600"
  ];

  return (
    <div className="relative h-screen flex items-center justify-center bg-gradient-to-br from-red-700 to-blue-800">
      {/* Overlay Section */}
      <div className="bg-black/50 p-8 md:p-12 rounded-lg text-center max-w-3xl w-full shadow-xl backdrop-blur-md">
        {/* Header Label */}
        <p className="text-green-400 font-medium tracking-wider mb-4 text-sm md:text-base uppercase">
          Academy for Business
        </p>

        {/* Main Heading */}
        <h1 className="font-extrabold text-3xl md:text-4xl lg:text-5xl mb-5 leading-tight text-red-100">
          Build cybersecurity <br /> talent from within.
        </h1>

        {/* Subtext */}
        <p className="text-blue-100 text-base md:text-lg mb-8 leading-relaxed">
          An interactive and guided skills development platform for corporate IT teams looking to master
          Offensive, Defensive, and General Cybersecurity.
        </p>

        {/* Button */}
        <button className="bg-red-500 hover:bg-blue-500 text-white font-bold px-8 py-4 rounded-md transition-colors">
          Get a demo
        </button>

        {/* Logos Section */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-6">
          {logos.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Logo ${index}`}
              className="h-14 w-14 object-cover rounded-full shadow-md hover:scale-110 transition-transform duration-300"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CyberSecurityLanding;
